import { render, staticRenderFns } from "./Revisite.vue?vue&type=template&id=da689230&scoped=true&"
import script from "./Revisite.vue?vue&type=script&lang=js&"
export * from "./Revisite.vue?vue&type=script&lang=js&"
import style0 from "./Revisite.vue?vue&type=style&index=0&id=da689230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da689230",
  null
  
)

export default component.exports